import { CONTACT_SUPPORT_SHORTCUT_ID } from "@src/appV2/App/AppShortcuts/constants";
import type { AppShortcutContext, AppShortcutDefinition } from "@src/appV2/App/AppShortcuts/types";
import { APP_V2_APP_EVENTS, logError } from "@src/appV2/lib/analytics";
import { openZendeskMessaging } from "@src/appV2/lib/ZendeskMessaging/openZendeskMessaging";
import {
  clearShortcuts,
  isAppShortcutsAvailable,
  setShortcuts,
} from "@src/appV2/NativeAdapters/appShortcuts.adapter";

const SHORTCUTS: readonly AppShortcutDefinition[] = [
  {
    id: CONTACT_SUPPORT_SHORTCUT_ID,
    title: "Contact Support",
    description: "Get 24/7 support",
    iosIcon: "message.fill",
    androidIcon: "ic_message",
    shouldRegister: ({ isAuthorized }) => isAuthorized,
    onClick: async ({ isAuthorized }) => {
      if (!isAuthorized) {
        return;
      }

      await openZendeskMessaging();
    },
  },
];

export async function registerShortcuts(context: AppShortcutContext) {
  if (!isAppShortcutsAvailable()) {
    return;
  }

  try {
    const shortcuts = SHORTCUTS.filter((shortcut) => shortcut.shouldRegister?.(context) ?? true);

    if (shortcuts.length === 0) {
      await clearShortcuts();
      return;
    }

    await setShortcuts(
      shortcuts.map(({ id, title, description, iosIcon, androidIcon }) => ({
        id,
        title,
        description,
        iosIcon,
        androidIcon,
      }))
    );
  } catch (error) {
    logError(APP_V2_APP_EVENTS.APP_SHORTCUT_SYNC_FAILURE, {
      error,
      metadata: { ...context },
    });
  }
}

export async function handleShortcutClick(shortcutId: string, context: AppShortcutContext) {
  const shortcut = SHORTCUTS.find(({ id }) => id === shortcutId);

  if (!shortcut?.onClick) {
    return;
  }

  try {
    await shortcut.onClick(context);
  } catch (error) {
    logError(APP_V2_APP_EVENTS.APP_SHORTCUT_ACTION_FAILURE, {
      error,
      metadata: { shortcutId, ...context },
    });
  }
}
